import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { DOCUMENT, effect, inject } from '@angular/core';

export const BodyOverflowStyleStateStore = signalStore(
  { providedIn: 'root' },
  withState({ subscriberAmount: 0 }),
  withMethods(store => ({
    subscribe(): void {
      patchState(store, { subscriberAmount: store.subscriberAmount() + 1 });
    },
    unsubscribe(): void {
      const currentSubscriberAmount = store.subscriberAmount();
      if (currentSubscriberAmount > 0) patchState(store, { subscriberAmount: currentSubscriberAmount - 1 });
    },
  })),
  withHooks(store => {
    const doc = inject(DOCUMENT);

    effect(() => {
      doc.body.style.overflow = store.subscriberAmount() > 0 ? 'hidden' : 'auto';
    });

    return {};
  }),
);
